import React from 'react';
import { MujiLink } from '@souche-f2e/muji';

export default function () {
  return (
    <div>
      <p>本文档为 <strong>测试 / Stable 文档</strong>，如需查看 <strong>预发 / 生产文档</strong>，请点击 <MujiLink to="/documents/docs">预发 / 生产文档</MujiLink></p>
      <br />
      <p>请在左侧菜单栏选择需要查看的 API 文档</p>
      <br />
      <p>接入指南请参考 <a style={{color: '#1890ff'}} href="#/documents/docking_process">对接流程</a></p>
    </div>
  )
}
